import { IStyle } from '@fluentui/react';
import { IH2OTheme } from '@h2oai/ui-kit';

export interface IRegisterFeatureSetSelectProjectStyles {
  root?: IStyle;
  body?: IStyle;
}

export interface IRegisterFeatureSetSelectProjectClassNames {
  root: string;
  body: string;
}

export const registerFeatureSetSelectProjectStylesDefault = (
  _theme: IH2OTheme
): Partial<IRegisterFeatureSetSelectProjectStyles> => ({
  root: {
    flex: 1,
    height: '100%',
    paddingTop: 17,
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
  },
  body: { flex: 1, minHeight: 0 },
});
